import repository from '@/repositories/Repository'

const resource = '/announcements'

/**
 * お知らせ
 */
export default {
  /**
   * 未読
   */
  hasUnread() {
    return repository.bizoo.get(`${resource}/has_unread`).then(r => r.data)
  },

  /**
   * 取得
   */
  get() {
    return repository.bizoo.get(`${resource}`).then(r => r.data)
  },
}
